module.exports = __webpack_public_path__ + "static/img/credit.23352177.gif";